/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum HubSpotManagementAction {
    ORDER_TO_DEAL = 'order_to_deal',
    CUSTOMER_TO_CONTACT = 'customer_to_contact',
}
